export default __webpack_public_path__ + "static/banner_back-644e1cdf9c683b54d12d10fee71e88fe.webp";